import Splide from '@splidejs/splide';
import generateTabs from '../components/generateTabs';
import '../../styles/pages/video-article.scss';
import '../../styles/blocks/article/fund.scss'
import "../../styles/blocks/article/related-tags-news.scss"
import copyToClipboard from '../components/copy-to-clipboard-func'
generateTabs('sidebar-last', { isLoadMore: false, initialTab: 'videoNews' });
generateTabs('sidebar-last-mob', { isLoadMore: false, initialTab: 'videoNews' });

const allVideoSliders = document.querySelectorAll('.splide-video-slider');

window.addEventListener('load', () => {
  let script = document.createElement('script');
  script.src = "https://www.youtube.com/player_api";

  document.body.append(script);
})

const videoFrameWrapper = document.querySelector('.video-frame-wrapper');
const videoFrameWrapperImage = videoFrameWrapper.querySelector('.video-frame-wrapper__image');

if (videoFrameWrapperImage) {
  videoFrameWrapperImage.addEventListener('click', () => {
    const player = new YT.Player('ytplayer', {
      height: '360',
      width: '640',
      events: {
        'onReady': onPlayerReady,
        //  'onStateChange': onPlayerStateChange
      },
      videoId: window.youtubeId,
      // start timecode
      startSeconds: parseInt(window.youtubeTimeCode),
      color: 'red',
      rel: 0,
    });

    function onPlayerReady() {
      videoFrameWrapperImage.classList.add('video-frame-wrapper__image_hidden');
      player.loadVideoById({
        videoId: window.youtubeId,
        startSeconds: parseInt(window.youtubeTimeCode),  // Start from the specified timecode
      });
      player.playVideo()
    }
  });
}

allVideoSliders.forEach((itm) => {
  const splide = new Splide(itm, {
    type: 'loop',
    perPage: 4,
    perMove: 1,
    pagination: false,
    gap: 32,
    flickPower: 100,
    breakpoints: {
      768: {
        perPage: 2,
      },
      1024: {
        perPage: 3,
        gap: 24,
      },
    }
  });

  splide.mount();
})

document.querySelector('.sidebar-last .load-more').addEventListener('click', function (e) {
  let active_tab = e.target.closest('.sidebar-last').querySelector('.tabs__item_active').dataset.tab || 'all';
  let tab_content = e.target.closest('.sidebar-last').querySelector(`[data-tabdata=${active_tab}]`);
  load_posts('/load-posts/', tab_content, 'list', tab_content.dataset.page, active_tab);
});

const videoFrame = document.querySelector('.video-frame-wrapper');
const closeBtn = videoFrame.querySelector('.video-frame-wrapper__close');

closeBtn.onclick = () => {
  videoFrame.classList.remove('video-frame-wrapper_scrollable');
  closeBtn.classList.remove('video-frame-wrapper__close_active');
  window.removeEventListener('scroll', makeIframeScrollable);
}

const makeIframeScrollable = () => {
  const border = window.matchMedia('(max-width: 1024px)').matches ? 165 : 500;

  if (window.scrollY > border) {
    if (videoFrame.classList.contains('video-frame-wrapper_scrollable')) return;
    videoFrame.classList.add('video-frame-wrapper_scrollable');
    closeBtn.classList.add('video-frame-wrapper__close_active');
  } else {
    videoFrame.classList.remove('video-frame-wrapper_scrollable');
    closeBtn.classList.remove('video-frame-wrapper__close_active');
  }
}

if (window.scrollY < 500) {
  window.addEventListener('scroll', makeIframeScrollable);
}

// copy to clipboard
const shareBtns = document.querySelectorAll('.share-button');
shareBtns.forEach((itm) => {
  itm.addEventListener('click', async () => {
    try {
      if (navigator.share) {
        await navigator.share({
          url: window.location.href
        });
      } else {
        const img = itm.querySelector('img');
        if (!img) return;
        await copyToClipboard(window.location.href);
        img.src = '/static/news/img/base/check_mark.png';

        setTimeout(() => {
          img.src = '/static/news/img/base/share.svg';
        }, 2000)
      }
    } catch (err) {
      console.log(err)
    }
  })
})